module.exports = __webpack_public_path__ + "img/mx.c8cda1d2.svg";